import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { icons } from '../../assets/emobilityIcons';
import { notNullOrEmpty } from '../../utils/common';
import { toolCodes } from './constants';

const useStyles = makeStyles({ name: 'EmobilityToolIcon' })(() => ({
	root: {
		width: 130
	}
}));

export type EmobilityToolIconProps = {
	toolCode: string;
	className?: string;
};

export const EmobilityToolIcon: React.FC<EmobilityToolIconProps> = (props) => {
	const { toolCode, className } = props;
	const src = resolveSrc(toolCode);

	const { classes, cx } = useStyles();

	return notNullOrEmpty(src)
		? <img src={src} className={cx(classes.root, className)} alt={toolCode} />
		: null;
};

const resolveSrc = (toolCode: string) => {
	switch (toolCode) {
		case toolCodes.TcoCalculator: return icons.tcoCalculator;
		case toolCodes.ChargeMap: return icons.chargeMap;
		case toolCodes.ChargingCalculator: return icons.chargingCalculator;
		case toolCodes.RangeCalculator: return icons.rangeCalculator;
		case toolCodes.MspTariffCalculator: return icons.mspTariffCalculator;
		case toolCodes.FuelSavingsCalculator: return icons.fuelSavingsCalculator;
		default: return null;
	}
};
